<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('visitation.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('visitation.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="d-flex justify-content-between">
          <div class="ts-flex ts-items-center ts-space-x-3" style="width:70%">
            <ts-button outline color="info" @click.prevent="addNew">
              {{ $t('add_new') }}
            </ts-button>
            <a-range-picker
              v-model="dateRange"
              :allowClear="false"
              format="DD-MM-YYYY"
              valueFormat="DD-MM-YYYY"
              style="width: 200px"
              @change="fetchData()"
            />
            <a-select
              v-model="province" 
              show-search
              option-filter-prop="children"
              :filter-option="filterOption"            
              style="width: 90%; min-width: 300px"
              mode="multiple"
              :options="provinces"
              @change="fetchData()"
            ></a-select>
          </div>
          <div class="d-flex ts-space-x-3">
            <ts-input
              v-model="search"
              v-tooltip="$t('visitation.search')"
              :placeholder="$t('search')"
              style="width: 250px;"
              class="inline-block"
            />
            <!-- <ts-filter ref="filter">
              <div class="row">
                <div class="col-md-12">
                  <label class="">{{ $t('customerProfile.branchName') }}</label>
                  <ts-branch-filter
                    @filter="branchFilter" 
                    class="ts-w-full"
                  ></ts-branch-filter>
                </div>
              </div>
            </ts-filter> -->
          </div>
        </div>
      </ts-card-wrapper>
      <div class="ts-overflow-auto">
        <ts-table
          :columns="columns"
          :records="resources"
          :loading="loading"
          :expandable="true"
        >
          <template v-slot="{ record }">
            <td>{{ record.plan_date }}</td>
            <td>{{ record.sale_name }}</td>
            <td class="ts-text-center">{{ record.working_hour }}</td>
            <td class="ts-text-center">{{ record.actual_working_hour }}</td>
            <td class="ts-text-center">{{ record.total_shop }}</td>
            <td class="ts-text-center">{{ record.total_shop_visited }}</td>
            <td class="ts-text-center">{{ record.total_distance }}</td>
            <td class="ts-text-center">{{ record.status }}</td>
            <td class="text-center ts-space-x-3">
              <a
                href="#"
                v-tooltip="$t('edit')"
                class="text-primary"
                @click.prevent="vieMap(record)"
              >
                <i class="fas fa-map"></i>
              </a>
              <a
                href="#"
                v-tooltip="$t('edit')"
                class="text-primary"
                @click.prevent="edit(record)"
              >
                <i class="fas fa-edit"></i>
              </a>
              <!-- <a-popconfirm
              placement="leftTop"
              :title="$t('are_you_sure_to_delete')"
              :ok-text="$t('yes')"
              :cancel-text="$t('no')"
              @confirm="deleteRecord(record)"
            >
              <a href="#" :disabled="record._deleting">
                <i class="fas fa-circle-notch spin" v-if="record._deleting"></i>
                <i class="fa fa-trash text-red" v-else></i>
              </a>
            </a-popconfirm> -->
            </td>
          </template>
          <template v-slot:expand="{ record }">
            <table class="ts-w-full">
              <thead>
                <tr>
                  <th>#</th>
                  <th>{{ $t('visitation.shopName') }}</th>
                  <th>{{ $t('visitation.province') }}</th>
                  <th>{{ $t('visitation.district') }}</th>
                  <th>{{ $t('visitation.commune') }}</th>
                  <th class="ts-text-center">{{ $t('visitation.checkIn') }}</th>
                  <th class="ts-text-center">
                    {{ $t('visitation.checkOut') }}
                  </th>
                  <th class="ts-text-center">
                    {{ $t('visitation.durationPlan') }}
                  </th>
                  <th class="ts-text-center">
                    {{ $t('visitation.actualDuration') }}
                  </th>
                  <th>{{ $t('visitation.status') }}</th>
                  <th class="ts-text-center">{{ $t('actions') }}</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(d, index) in record.json_visitation_detail"
                  :key="index"
                >
                  <td>{{ index + 1 }}</td>
                  <td>{{ d.customer_name }}</td>
                  <td>{{ d.province_name_en }}</td>
                  <td>{{ d.district_name_en }}</td>
                  <td>{{ d.commune_name_en }}</td>
                  <td class="ts-text-center">{{ d.check_in_time }}</td>
                  <td class="ts-text-center">{{ d.check_out_time }}</td>
                  <td class="ts-text-center">{{ d.duration_plan + ' min' }}</td>
                  <td class="ts-text-center">
                    {{ d.actual_duration + ' min' }}
                  </td>
                  <td>{{ d.visitation_status }}</td>
                  <td class="ts-text-center">
                    <a href="#" @click.prevent="shopView(d, record)">
                      <i class="fas fa-image"></i>
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
          </template>
        </ts-table>
      </div>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination
          v-model="pagination"
          @navigate="fetchData"
        ></ts-pagination>
      </div>
      <!-- form-action -->
      <a-modal
        v-if="show_map"
        v-model="show_map"
        :title="$t('visitation.viewMap')"
        centered
        :zIndex="1020"
        :footer="null"
        :maskClosable="false"
        width="100%"
      >
        <VieMap :record="recordData" />
      </a-modal>
      <!-- form-action -->
      <a-modal
        v-if="show_specific_map"
        v-model="show_specific_map"
        :title="$t('visitation.viewMap')"
        centered
        :zIndex="1020"
        :footer="null"
        :maskClosable="false"
        width="70%"
      >
        <VieMapShop :record="recordData" :shop="shopRecord" />
      </a-modal>
    </ts-card>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapActions, mapState } from 'vuex'
import VieMap from './components/view-map.vue'
import VieMapShop from './components/view-map-shop.vue'

export default {
  name: 'customerProfileIndex',
  components: {
    VieMap,
    VieMapShop
  },
  data() {
    return {
      loading: false,
      show_map: false,
      show_specific_map: false,
      shopRecord: [],
      recordData: [],
      provinces: []
    }
  },
  computed: {
    ...mapState('customer/visitation', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.customer.visitation.search
      },
      set(newValue) {
        this.$store.commit('customer/visitation/SET_SEARCH', newValue)
        this.$store.commit('customer/visitation/RESET_CURRENT_PAGE')
      }
    },
    province: {
      get() {
        return this.$store.state.customer.visitation.provinces
      },
      set(newValue) {
        this.$store.commit('customer/visitation/SET_SET_PROVINCE', newValue)
      }
    },
    columns() {
      return [
        { name: this.$t('visitation.date') },
        { name: this.$t('visitation.saleName') },
        {
          name: this.$t('visitation.workingHoursPlan'),
          style: 'text-align:center;'
        },
        {
          name: this.$t('visitation.actualWorkingHour'),
          style: 'text-align:center;'
        },
        {
          name: this.$t('visitation.totalShopPlan'),
          style: 'text-align:center;'
        },
        {
          name: this.$t('visitation.totalShopVisited'),
          style: 'text-align:center;'
        },
        {
          name: this.$t('visitation.totalLength'),
          style: 'text-align:center;'
        },
        { name: this.$t('visitation.status'), style: 'text-align:center;' },
        { name: this.$t('actions'), style: 'text-align:center; width: 1px;' }
      ]
    },
    dateRange: {
      get() {
        return this.$store.state.customer.visitation.dateRange
      },
      set(newValue) {
        this.$store.commit('customer/visitation/SET_DATE_RANGE', newValue)
      }
    }
  },
  methods: {
    ...mapActions('customer/visitation', ['getFormViewModel']),
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('customer/visitation/fetch', { ...attributes })
        .then(() => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    fetchProvince() {
      this.loading = true
      this.getFormViewModel({
        fnName: 'province'
      })
        .then(response => {
          this.provinces = response.data['province'].map(el => ({
            value: el.province_code,
            label: el.name_kh
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    addNew() {
      // this.showForm = true
      this.$router.push({ name: 'visitation-plan-create' })
    },
    edit(record) {
      this.$router.push({
        name: 'visitation-plan-edit',
        params: {
          id: record.plan_id
        }
      })
    },
    clearEdit() {
      this.$store.commit('customer/visitation/SET_EDIT_DATA', {})
      this.showForm = false
      this.fetchData()
    },
    vieMap(record) {
      this.show_map = true
      this.show_specific_map = false
      this.recordData = record
    },
    shopView(shop, record) {
      this.show_map = false
      this.show_specific_map = true
      this.shopRecord = shop
      this.recordData = record
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
    // deleteRecord(record) {
    //   record._deleting = true
    //   this.$store
    //     .dispatch('customer/visitation/destroy', record.customer_id)
    //     .then(response => {
    //       this.$toasted.success(response.message)
    //       this.fetchData()
    //     })
    //     .catch(error => {
    //       this.$toasted.error(error.message)
    //     })
    //     .finally(() => {
    //       record._deleting = false
    //     })
    // },
    // branchFilter(value){
    //   this.$store.commit('customer/visitation/SET_BRANCH_ID', value)
    //   this.fetchData()
    // }
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData()
    }, 500)
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.fetchData()
      vm.fetchProvince()
    })
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('customer/visitation/RESET_STATE')
    next()
  }
}
</script>
